import React, { useCallback, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Permission from "../../../components/Common/Permission";
import {
  FieldsContainer,
  FieldsSection,
  FlexContainer,
} from "../../../constants/assets/containers";
import Back from "sushiweb/Icons/all/Back";
import Breadcrumb from "sushiweb/Breadcrumb";
import CameraAdd from "sushiweb/Icons/all/CameraAdd";
import VideoTv from "sushiweb/Icons/all/VideoTv";
import PaginatedReactDropdown from "../../../components/Common/PaginatedReactDropdown";
import Input from "sushiweb/InputTypes/Input";
import DateTimePicker from "../../../components/Common/DateTimePicker";
import Button from "sushiweb/Button";
import CrossCircle from "sushiweb/Icons/all/CrossCircle";
import SpinnerCircular from "sushiweb/Spinner/SpinnerCircular";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import variables from "../../../constants/assets/variables";
import * as DriverStoriesActions from "../../../store/actions/DriverStories";

import { isValNull, debounce } from "../../../utils";
import GeographySelectionModal from "../../../components/DriverStories/GeographySelectionModal";
import NoFooterModal from "../../../components/Common/NoFooterModal";
import ImageUploader from "../../../components/Common/ImageUploader";
import VideoUploader from "../../../components/Common/VideoUploader";
import BulkCsvUploadFile from "../../../components/DriverStories/BulkCsvUploadFile/BulkCsvUploadFile";

const driverSelectionOptions = [
  { key: "GEOGRAPHY", label: "Geography" },
  { key: "CSV", label: "CSV" },
];

const SUPPORTED_VIDEO_FORMAT = [".m3u8", ".mp4"];

const NewExternalBrandEntity = (props) => {
  const {
    uploadCampaignImage,
    uploadCampaignVideo,
    driverSelectionCSVUpload,
    uploadedImageName,
    uploadedVideoName,
    activeFilePath,
    createExternalEntity
  } = props;

  const history = useHistory();
  const allActions = MenuActionsMappings[MenuNames.DRIVER_STORIES];
  const [initialState, setInitialState] = useState({
    name: "",
    upload_cohort_type: "",
    media_type: "VIDEO",
    csv_file_s3_key: "",
    image_name: "",
    image_url: "",
    video_url: "",
    video_name: "",
    cdn_video_url: "",
  });
  const [modalState, setModalState] = useState(false);
  const [callback_key, setCallback_key] = useState("");
  const [presign_url, setPresign_url] = useState("");
  const [downloadUrl, setDownloadUrl] = useState("");
  const [formError, setFormError] = useState("");
  const [isUploading, setIsUploading] = useState(false);


  let now = new Date();
  let currentDateTime = now.toISOString().slice(0, 16);
  let sevenDaysFromNow = new Date();
  sevenDaysFromNow.setDate(now.getDate() + 7);
  let sevenDaysLater = sevenDaysFromNow.toISOString().slice(0, 16);
  

  const handleChange = (key, val, inputEvent = undefined) => {
    setFormError("");
    switch (key) {
      case "media_type":
        setInitialState((prevState) => ({
          ...prevState,
          [key]: val,
        }));
        if (typeof inputEvent !== "undefined") {
          const updateState = { ...initialState };
          updateState.cdn_video_url = inputEvent;
          updateState[key] = val;
          setInitialState(updateState);
          setInitialState((prevState) => ({
            ...prevState,
            cdn_video_url: inputEvent,
          }));
          //if input url then don't open modal
          return;
        }
        setModalState(val);
        break;
        
      default:
        setInitialState((prevState) => ({
          ...prevState,
          [key]: val,
        }));
    }
  };

  const handleBackClick = () => {
    history.push(`/stories`);
  };


  const validateDetails = () => {
    if (!initialState.name) {
      return generateErrorText("Brand Name");
    }
    if (!initialState.image_url) {
      return generateErrorText("Image");
    }
    return "validated";
  };
  
  const handleCreateStoryBrand = () => {
    let validatedState = validateDetails();
    if (validatedState === "validated") {
      createExternalEntity(initialState).then(() => {
        history.push("/stories");
        window.location.reload();
      });
    } else {
      setFormError(validatedState);
    } 
  };

  const generateErrorText = (
    fieldLabel,
    trailingText = "field is mandatory"
  ) => {
    return `${fieldLabel} ${trailingText}`;
  };

  const handleCloseModal = () => {
    setModalState(false);
  };

  const handleCrossClick = (mediaType) => {
    if (mediaType === "IMAGE") {
      setInitialState({ ...initialState, image_url: "", image_name: "" });
    } else if (mediaType === "VIDEO") {
      setInitialState({ ...initialState, video_url: "", video_name: "" });
    }
  };

  const handleImageChange = (file) => {
    //make api call -> image upload
    const payload = {
      filename: file.name,
    };
    uploadCampaignImage(payload).then((res) => {
      setDownloadUrl(res.download_url);
      setCallback_key(res.callback_key);
      setPresign_url(res.upload_url);
      setIsUploading(true);
    });
  };

  const handleVideoChange = (file) => {
    //make api call -> image upload
    const payload = {
      filename: file.name,
    };
    uploadCampaignVideo(payload).then((res) => {
      setDownloadUrl(res.download_url);
      setCallback_key(res.callback_key);
      setPresign_url(res.upload_url);
      setIsUploading(true);
    });
  };

  const handleUrlChange = (mediaType) => {
    if (mediaType === "IMAGE") {
      const values = { ...initialState };
      values.image = downloadUrl;
      values.image_name = uploadedImageName;
      values.image_url = downloadUrl;
      setInitialState((prevState) => ({
        ...prevState,
        video: "",
        video_name: "",
        video_url: "",
        image: downloadUrl,
        image_name: uploadedImageName,
        image_url: downloadUrl,
      }));
    } else if (mediaType === "VIDEO") {
      setInitialState((prevState) => ({
        ...prevState,
        image: "",
        image_name: "",
        image_url: "",
        video: downloadUrl,
        video_name: uploadedVideoName,
        video_url: downloadUrl,
      }));
    }

    // now, resetting the callback key and presign url
    setCallback_key("");
    setPresign_url("");
    setDownloadUrl("");
    setModalState(false);
    setIsUploading(false);
  };

  const getModal = () => {
    switch (modalState) {
      case "IMAGE":
        return (
          <NoFooterModal
            header={true}
            heading={`Upload Image`}
            handleClose={handleCloseModal}
            id="storiesMediaUploadModal"
          >
            <FlexContainer justify="flex-start">
              <FlexContainer>
                {!(downloadUrl && isUploading) ? (
                  <>
                    <ImageUploader
                      handleImageChange={handleImageChange}
                      id={`imageUpload`}
                      state="Add"
                      imageKey={"thumbnail"}
                      uploadUrl={"/stories/upload_image/ack"}
                      callback_key={callback_key}
                      presign_url={presign_url}
                      keyName="callback_key"
                      maxSize={2}
                      handleImageUrlChange={() => handleUrlChange(modalState)}
                    />
                    <div className="flex mb-26 ml-26 text-grey pill">
                      <ul>
                        <li>Maximum Image Size: 2 MB</li>
                        <li>Supported types: "PNG/JPG/JPEG"</li>
                        <li>Image should be in 1:1 (portrait)</li>
                      </ul>
                    </div>
                  </>
                ) : (
                  <SpinnerCircular
                    size="large"
                    color={variables.grey500}
                    className="justify-between"
                  />
                )}
              </FlexContainer>
            </FlexContainer>
          </NoFooterModal>
        );

      case "VIDEO":
        return (
          <NoFooterModal
            header={true}
            heading={`Upload Video`}
            handleClose={handleCloseModal}
            id="storiesMediaUploadModal"
          >
            <FlexContainer justify="flex-start">
              <FlexContainer>
                {!(downloadUrl && isUploading) ? (
                  <>
                    <VideoUploader
                      handleVideoChange={handleVideoChange}
                      id={`imageUpload`}
                      state="Add"
                      imageKey={"thumbnail"}
                      uploadUrl={"/stories/upload_video/ack"}
                      callback_key={callback_key}
                      presign_url={presign_url}
                      keyName="callback_key"
                      maxSize={20}
                      handleVideoUrlChange={() => handleUrlChange(modalState)}
                      noAckCall
                    />
                    <div className="flex mb-26 ml-26 text-grey pill">
                      <ul>
                        <li>Maximum Image Size: 20 MB</li>
                        <li>Supported types: "MP4/M3U8"</li>
                        <li>Video should be in 9:16 (portrait)</li>
                      </ul>
                    </div>
                  </>
                ) : (
                  <SpinnerCircular
                    size="large"
                    color={variables.grey500}
                    className="justify-between"
                  />
                )}
              </FlexContainer>
            </FlexContainer>
          </NoFooterModal>
        );
      default:
        return;
    }
  };

  const MediaAttachment = ({ mediaType }) => {
    const disabled =
      (mediaType === "IMAGE"
        ? initialState.video_url.length
        : initialState.image_url.length) ||
      isUploading ||
      initialState.cdn_video_url;
    const containerText =
      mediaType === "IMAGE" ? "Upload Image" : "Upload Video";
    const multimediaName =
      mediaType === "IMAGE" ? initialState.image_name : initialState.video_name;
    const icon =
      mediaType === "IMAGE" ? (
        <CameraAdd
          color={disabled ? variables.grey500 : variables.red500}
          size={20}
        />
      ) : (
        <VideoTv
          color={disabled ? variables.grey500 : variables.red500}
          size={20}
        />
      );

    return (
      <React.Fragment>
        <MediaUploadContainer justify="flex-start" disabled={disabled}>
          <UploadMediaBar
            onClick={() => handleChange("media_type", mediaType)}
            disabled={disabled}
          >
            {icon}
            <span>{containerText}</span>
          </UploadMediaBar>
          {multimediaName ? (
            <>
              <FlexContainer>
                <p className="font-10 mb-15 ml-16 text-grey ">
                  {multimediaName}
                </p>
                <CrossCircle
                  onClick={() => handleCrossClick(mediaType)}
                  className="cross"
                  color={variables.red500}
                />
              </FlexContainer>
            </>
          ) : null}
          {downloadUrl &&
          isUploading &&
          initialState.media_type === mediaType ? (
            <SpinnerCircular size="small" color={variables.grey500} />
          ) : null}
        </MediaUploadContainer>
      </React.Fragment>
    );
  };

  useEffect(() => {
    if (activeFilePath) {
      setInitialState((prevState) => ({
        ...prevState,
        csv_file_s3_key: activeFilePath,
      }));
    } else {
      setInitialState((prevState) => ({
        ...prevState,
        driver_selection_type: "",
        csv_file_s3_key: "",
      }));
    }
  }, [activeFilePath]);

  return (
    <Permission requiredParams={[allActions.STORIES_CREATE]}>
      <section>
        <FlexContainer justify="flex-start">
          &emsp;
          <Back
            onClick={handleBackClick}
            className="mr-10 backBtn"
            color={variables.grey400}
          />
          <Breadcrumb className="sushi-breadcrumbs">
            <Breadcrumb.Link onClick={handleBackClick}>Stories</Breadcrumb.Link>
            <Breadcrumb.Link>Create new Brand</Breadcrumb.Link>
          </Breadcrumb>
        </FlexContainer>
        <FieldsContainer border noPadding className="mt-40">
          <FieldsHolder>
            <FieldsSection marginBottom="1.75rem">
              <p className="section-heading">BRAND DETAILS</p>
            </FieldsSection>
            <div>
                <FlexContainer className="justify-start">
                  <NamesDiv>
                    <p className="regular ml-5 mb-30">Brand Name</p>
                  </NamesDiv>
                  <InputElements>
                    <Input
                      value={initialState.name}
                      data-testid="name"
                      id="sushi-input"
                      onChange={(e) => handleChange("name", e)}
                      innerWidth="100%"
                    />
                  </InputElements>
                </FlexContainer>
              <FlexContainer className="justify-start">
                <NamesDiv>
                  <p className="regular ml-5 mb-30">Media</p>
                </NamesDiv>
                <InputElements className="upload">
                  <MediaAttachment mediaType="IMAGE" />
                </InputElements>
              </FlexContainer>
            </div>
            {formError.length > 0 ? (
              <div className={"error-state"}>{"*" + formError}</div>
            ) : (
              ""
            )}
          </FieldsHolder>
          <FlexContainer justify="flex-end">
            <NextButton>
              <Button
                data-testid="nextButton"
                className="sushi-btn w-25"
                onClick={handleCreateStoryBrand}
              >
                Create Brand
              </Button>
            </NextButton>
          </FlexContainer>
        </FieldsContainer>
        {modalState && getModal()}
      </section>
    </Permission>
  );
};

const NextButton = styled.div`
  flex: 0 1 65%;
  margin-bottom: 30px;
`;

const FieldsHolder = styled.div`
  padding: 1.875rem;
`;

const NamesDiv = styled.div`
  justify-content: flex-start;
  flex: 0 1 50%;
  p {
    font-family: "OkraRegular", -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
      sans-serif !important;
    letter-spacing: 1.25px;
  }
`;

const ExpirySection = styled.div`
  margin-bottom: 15px;
  padding-bottom: 15px;
  .expiryText {
    flex: 0 1 10%;
    height: 3rem;
    padding: 15px;
    margin-bottom: 15px;
  }
  .datepicker {
    flex: 0 1 50%;
    height: 50px;
    margin-bottom: 15px;
  }
  input {
    width: 98%;
  }
`;

const InputElements = styled.div`
  flex: 0 1 50%;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  &.upload {
    margin-bottom: 8px;
    div {
      display: flex;
      gap: 6px;
      margin-bottom: 10px;

      p {
        color: ${variables.red500};
      }
    }
  }
`;

const UploadMediaBar = styled(FlexContainer)`
  border: 2px solid
    ${(props) => (props.disabled ? variables.grey500 : variables.red500)};
  border-radius: 20px;
  padding: 3px 8px;
  width: 150px;
  span {
    color: ${(props) =>
      props.disabled ? variables.grey500 : variables.red500};
  }
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

const MediaUploadContainer = styled(FlexContainer)`
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

function mapStateToProps(state) {
  const { User } = state;
  return {
    uploadedImageName: User.uploadedImageName,
    uploadedFileName: User.uploadedFileName,
    uploadedVideoName: User.uploadedVideoName,
    activeFilePath: User.activeFilePath,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    driverSelectionCSVUpload: bindActionCreators(
      DriverStoriesActions.driverSelectionCSVUpload,
      dispatch
    ),
    uploadCampaignImage: bindActionCreators(
      DriverStoriesActions.uploadCampaignImage,
      dispatch
    ),
    uploadCampaignVideo: bindActionCreators(
      DriverStoriesActions.uploadCampaignVideo,
      dispatch
    ),
    createExternalEntity: bindActionCreators(
      DriverStoriesActions.createExternalEntity,
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewExternalBrandEntity);
